export const GET_TUTORIAL_VIDEO_REQUEST='tutorialVideosReducer/GET_TUTORIAL_VIDEO_REQUEST'
export const GET_TUTORIAL_VIDEO_SUCCESS='tutorialVideosReducer/GET_TUTORIAL_VIDEO_SUCCESS'
export const GET_TUTORIAL_VIDEO_FAILED='tutorialVideosReducer/GET_TUTORIAL_VIDEO_FAILED'